import { type ModalOverlayProps, Dialog, Heading, IconButton, Modal, ModalOverlay } from '@launchpad-ui/components';

import { FeedbackForm } from './FeedbackForm';

import styles from './ContextualFeedbackTrigger.module.css';

export type ContextualFeedbackModalProps = {
  /** Recipient flag key. Feedback is submitted to the qualitative feedback product via the SDK and tied to this flag. */
  flagKey: string;
} & ModalOverlayProps;

export function ContextualFeedbackModal({ flagKey, ...props }: ContextualFeedbackModalProps) {
  return (
    <ModalOverlay {...props}>
      <Modal size="small">
        <Dialog aria-label="Give feedback">
          {({ close }) => (
            <>
              <div className={styles.modalHeader}>
                <Heading slot="title">Give feedback</Heading>
                <IconButton aria-label="Close" icon="cancel" variant="minimal" onPress={close} />
              </div>
              <FeedbackForm flagKey={flagKey} />
            </>
          )}
        </Dialog>
      </Modal>
    </ModalOverlay>
  );
}
